/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { tableAvailabilitySchema } from "./tableAvailabilitySchema.ts";

export const sectionAvailabilitySchema = z.object({
	id: z.uuid(),
	name: z.string(),
	tables: z.array(tableAvailabilitySchema),
});
